
import {defineComponent, PropType} from "vue";
//@ts-ignore
import BaseBtModal from "@vueEntry/BaseBtModal.vue"
//@ts-ignore
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
//@ts-ignore
import BaseAlert from "@vueEntry/UIKitComponents/BaseAlert.vue";
import {getDefaultSearchBean} from "@wikicasa/common/model/RealEstateSearchBean";
import Place from "@wikicasa/common/model/Place";
import {COLORS, MAP_TILER_APIKEY} from "../../components/variables";
import LeafletMap from "@wkWebSrc/js/LeafletMap/leaflet_map";
import "../../../style/vendor/leafleft.theme.scss";
import {LatLng} from "leaflet";
import { validateMap, parsePoints, getPolygonString } from "@utils/MapUtils"
import { ENERGY_CLASS } from "@customTypes/EnergyClass"
import { BREAKPOINT } from "@customTypes/BreakpointEnum"
import {mapState, mapActions} from "pinia";
import {useBreakpoints}  from "@wkComposables/useBreakpoints";
import {useSearch} from "@wkComposables/useSearch";
import {getPlace} from "@services/placesAPI";
import {PMCustomEvent} from "@customTypes/PlaceModalEvent/PMCustomEvent";
//@ts-ignore
import BaseAutocomplete from "@vueEntry/UIKitComponents/BaseAutocomplete.vue";
import {SelectOptions} from "@customTypes/BaseInputTypes";
import {getPlacesAddressAutocomplete, getPlacesDetails, getAroundMePolygon} from "@services/geographyAPI";
import {GAutocompleteTypes, GooglePredictionType} from "@customTypes/GAutocompleteTypes";
import {googlePlaceConverter} from "@utils/GAutocompleteUtils";
import {Nullable} from "@customTypes/CustomUtilityTypes";
import {PLACE_TYPE} from "@customTypes/PlaceType";
import { getUserPosition, browserSupportGeolocation } from "@utils/GeolocationUtils"
import {useSearchBeanStore} from "@store/SearchBeanStore";

const USER_POSITION_ZOOM = 17;
const AROUNDME_POSITION_ZOOM = 13;
const DESKTOP_POSITION_ZOOM = 7;

interface Position {
    lat: number,
    lng: number,
    zoom: number
}
const DEFAULT_POSITION: Position = {lat: 41.902782, lng: 12.496366, zoom: 6}

export default defineComponent({
    name: "MapModal",
    components: {BaseBtModal, BaseButton, BaseAlert, BaseAutocomplete},
    props: {
        showMapModal: {
            type: Boolean,
            default: false
        },
        listing: {
            type: Boolean
        },
        aroundMe: {
            type: Boolean,
            default: false
        },
        previouslyAroundMe: {
            type: Boolean
        },
        place: {
            type: Object as PropType<Place>,
        }
    },
    emits: ["emit-place", "hide-map-modal"],
    setup() {
        const {
            isDesktopMode,
            isLarge,
        } = useBreakpoints()

        const { search } = useSearch()

        return {
            isDesktopMode,
            isLarge,
            //useSearch
            search
        }
    },
    data() {
        return {
            searchBeanModal: getDefaultSearchBean(),
            mapDrawing: false,
            hasPolygon: false,
            center: DEFAULT_POSITION,
            mapPlace: null as Place | null,
            map: null as null | LeafletMap,
            idUserPositionMarker: 0,
            mapPositionMarker: 1,
            loadingAroundMePolygon: false,
            currentRadius: 0, //meters
            currentMapIDbase: "draw-on-mobile_",
            currentMapID: "draw-on-mobile_" + Date.now(),
            // userLocationError = false,
            mapError: false,
            mapWarning: false,
            labelText: "",
            loading: false,
            isPlace: false,
            openMapModal: false,
            pmCustomEvent: null as null | PMCustomEvent,
            currentAddress: "",
            autocompleteDisabled: true
        }
    },
    computed: {
        cdn(): string {
            return window["_cdn"]
        },
        headerClasses(): string {
            //@ts-ignore
            return this.isDesktopMode ? "d-none" : "pb-10 pt-15";
        },
        labels(): Record<string, string> {
            return window["_labels"];
        },
        currentRadiusKm(): number {
            if (!this.currentRadius)
                return 0;

            return this.currentRadius / 1000;
        },
        isDesktop(): boolean {
            return window.screen.width > BREAKPOINT.SMALL;
        },
        ...mapState(useSearchBeanStore, ["searchBean"])
    },
    watch: {
        hasPolygon(cur, prev) {
            this.checkMapError();
        },
        mapPlace(cur, prev) {
            this.map?.startSpinner();
            this.map?.setCenter(cur.latitude, cur.longitude, USER_POSITION_ZOOM);
            this.map?.stopSpinner();
        },
        currentRadius(cur, prev) {
            this.updateAroundMePolygon();
        },
    },
    created() {
        this.openMapModal = this.showMapModal;
    },
    mounted() {
        this.mapWarning = false;
        this.searchBeanModal = JSON.parse(JSON.stringify(this.searchBean))
        this.searchBeanModal.listingTypologyURL = window._listingTypologyURL;
        this.idUserPositionMarker = Date.now();
        this.convertEnergyClassFilter();
        this.convertFloor();
        this.onOpened();
    },
    methods: {
        browserSupportGeolocation,
        async onInputChangeCb(query: string): Promise<any> {
            const res = await getPlacesAddressAutocomplete(query, 10, [GAutocompleteTypes.GEOCODE])
            return res.map((r: GooglePredictionType) => ({label: r.description, id: r.place_id}));
        },
        async optionSelectedCb(selectedEl:  Nullable<SelectOptions<any>>): Promise<void> {
            if(!selectedEl){
                this.isPlace = false;
                return;
            }

            //Removing the polygon iff there is a map error (e.g. area too large )
            !this.mapWarning && this.deletePolygon()

            const gPlaceDetails = await getPlacesDetails(`${selectedEl?.id}`);
            const curPlace = await googlePlaceConverter(gPlaceDetails, selectedEl.label);
            //const curAddress = curPlace.streetName ? formatAddress(curPlace.streetName, curPlace.streetNumber || "", curPlace.cityName) : curPlace.address;
            this.autocompleteDisabled = true;

            try {
                if (curPlace.placeType == PLACE_TYPE.CITY && curPlace.streetName) {
                    this.currentAddress = `${curPlace.streetName}`;

                    if (curPlace.streetNumber) {
                        this.currentAddress += ` ${curPlace.streetNumber}`;
                    }

                    if (curPlace.zip) {
                        this.currentAddress += ` ${curPlace.zip}`
                    }

                    this.currentAddress += `${curPlace.displayName}`.trim();
                } else
                    this.currentAddress = `${curPlace.displayName}`.trim();
            } catch (e) {
                this.currentAddress = `${curPlace.displayName}`.trim();
            }
            this.mapPlace = curPlace;
            this.isPlace = true;
            this.setCoordinates(this.mapPlace.latitude, this.mapPlace.latitude, USER_POSITION_ZOOM);
            this.updateMapCenter();
            this.map?.addMarker(this.idUserPositionMarker, new LatLng(this.mapPlace.latitude, this.mapPlace.longitude));
        },
        deletePolygonAndCloseModal() {
            this.deletePolygon();
            this.closeMapModal();
        },
        onOpened() {
            this.initMap();

            if (this.aroundMe)
                return;
        },
        convertEnergyClassFilter(): void {
            //@ts-ignore
            switch (this.searchBean.energyClassFilter) {
                case "HIGH": {
                    this.searchBeanModal.energyClassFilter = ENERGY_CLASS.HIGH;
                    break;
                }
                case "MEDIUM": {
                    this.searchBeanModal.energyClassFilter = ENERGY_CLASS.MEDIUM;
                    break;
                }
                case "LOW": {
                    this.searchBeanModal.energyClassFilter = ENERGY_CLASS.LOW;
                    break;
                }
            }
        },
        convertFloor(): void {
            this.searchBeanModal.floor = this.searchBeanModal.floorId;
        },
        checkMapError(): void {
            this.mapError = this.map ? !validateMap(this.map) : true;
            this.labelText = !this.aroundMe ? this.labels.mapTooLarge : this.labelText;
        },
        getPlaceFn(query: string): Promise<Array<Place>> {
            return getPlace(query);
        },
        setCoordinates(latitude: number, longitude: number, zoom: number) {
            this.center.lat = latitude;
            this.center.lng = longitude;
            this.center.zoom = zoom;
        },
        async loadingMapAroundMe(): Promise<void> {
            this.map?.startSpinner();
            if (!this.currentRadius)
                this.currentRadius = 1000;
            try {
                const positionCb = getUserPosition();
                if(!positionCb)
                    throw new Error("Localitation not available")

                const position = await positionCb

                this.mapWarning = false;
                this.map?.stopSpinner()
                const pos = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                };
                this.setCoordinates(pos.lat, pos.lng, AROUNDME_POSITION_ZOOM)
                this.updateMapCenter();
                //controllare se effettivamente serve
                if (!this.aroundMe)
                    this.map?.addMarker(this.idUserPositionMarker, pos);

                await this.updateAroundMePolygon();
            } catch (error) {
                console.error("user position errore", error);
                //1 is permission denied
                if (error.code == 1) {
                    this.labelText = this.labels.positionNotAllowed;
                }
                // every other errors
                else {
                    this.labelText = this.labels.errorTryAgain;
                }
                this.mapWarning = true;
                this.map?.removeMarker(this.idUserPositionMarker);
                this.center.zoom = AROUNDME_POSITION_ZOOM;
                await this.updateAroundMePolygon();
                this.map?.stopSpinner();
            }
        },
        async updateAroundMePolygon(): Promise<void> {
            this.loadingAroundMePolygon = true;
            const response = await getAroundMePolygon(this.center.lat, this.center.lng, this.currentRadius)

            try {
                if (!response.data)
                    return;
                this.searchBeanModal.polygonFromMap = response.data;
                this.drawPolygon(response.data);
            } catch (error) {
                console.error(error)
            } finally {
                this.loadingAroundMePolygon = false;
            }
        },
        getPosition(): void {
            this.map?.startSpinner();
            getUserPosition()?.then(
                (position) => {
                    this.map?.stopSpinner()
                    this.mapWarning = false;
                    this.deletePolygon();
                    const pos = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    };
                    this.setCoordinates(pos.lat, pos.lng, USER_POSITION_ZOOM);
                    this.updateMapCenter();
                    this.map?.addMarker(this.idUserPositionMarker, pos);
                    this.map?.stopSpinner();

                },
                (error) => {
                    //map.setCenter(DEFAULT_POSITION.lat, DEFAULT_POSITION.lng, DEFAULT_POSITION.zoom);
                    if (error.code == 1) {
                        this.labelText = this.labels.positionNotAllowed;
                    } else {
                        this.labelText = this.labels.errorTryAgain;
                    }
                    this.mapWarning = true;
                    this.map?.removeMarker(this.idUserPositionMarker);
                    this.map?.stopSpinner();

                }
            );
        },
        updateMapCenter(): void {
            this.map?.removeMarker(this.idUserPositionMarker);
            this.map?.setCenter(this.center.lat, this.center.lng, this.center.zoom);
        },
        initMap(): void {

            this.map = new LeafletMap();

            const map_selector = this.$refs.mapPlaceholder as HTMLDivElement;

            this.map?.init(map_selector, MAP_TILER_APIKEY, COLORS);

            this.map?.ready(async () => {

                if (this.aroundMe)
                    await this.loadingMapAroundMe();
                else if (!this.listing && this.previouslyAroundMe) {
                    this.searchBeanModal.polygonFromMap = "";
                    this.searchBeanModal.polygonForDB = "";
                    this.deletePolygon();
                } else if (this.searchBeanModal.polygonFromMap || this.searchBeanModal.polygonForDB) {
                    this.hasPolygon = true;
                    this.mapDrawing = true;
                    this.searchBeanModal.polygonForDB ? this.drawPolygon(this.searchBeanModal.polygonForDB) : this.drawPolygon(this.searchBeanModal.polygonFromMap);
                } else {
                    this.map?.setCenter(this.center.lat, this.center.lng, (window.screen.width > BREAKPOINT.SMALL) ? DESKTOP_POSITION_ZOOM : this.center.zoom)
                    this.hasPolygon = false;
                    this.mapDrawing = false;
                }


                let isBgImageShown = true;
                const removeBgImage = (): void => {

                    if (!isBgImageShown)
                        return;

                    map_selector.style.backgroundImage = "none";
                    isBgImageShown = false;
                }

                this.map?.on("zoomstart", removeBgImage);
                this.map?.on("draw:created", () => {
                    this.hasPolygon = true;
                })
            })
        },
        drawPolygon(polygon: string): void {
            const latLngs = parsePoints(polygon);
            if (latLngs) {
                if (this.map?.getMap()) {
                    this.map?.deleteShape();
                    this.map?.getMap()?.invalidateSize();
                }
                //@ts-ignore
                this.map?.drawPolygonFromPoints(latLngs);
                this.map?.fitBounds(this.map?.getShape()?.getBounds());
            }
            this.checkMapError();
        },
        startDrawing(): void {
            this.mapError = false;
            this.mapWarning = false;
            this.hasPolygon = false;
            this.mapDrawing = true;
            this.map?.setDrawing();
        },
        deletePolygon(): void {
            this.hasPolygon = false;
            this.mapError = false
            this.mapDrawing = false;
            this.searchBeanModal.polygonFromMap = "";
            this.searchBeanModal.polygonForDB = "";
            this.updateSearchBean({
                polygonFromMap: "",
                polygonForDB: ""
            });
            this.map?.deleteShape();
            this.map?.stopDrawing();
        },
        confirmPolygon(): void {
            this.loading = true;
            this.checkMapError();

            if (!this.mapError) {
                this.searchBeanModal.polygonForDB = getPolygonString(this.map?.getShapePoints() as LatLng[]);
                this.searchBeanModal.polygonFromMap = this.map ? this.map?.getShapePoints().map((point: LatLng) => `${point.lat},${point.lng};`).join("") : "";
                if (this.listing) {
                    this.updateSearchBean({
                        polygonForDB: this.searchBeanModal.polygonForDB,
                        polygonFromMap: this.searchBeanModal.polygonFromMap,
                        areaOfInterestId: undefined,
                        areaId: undefined,
                        placeType: undefined,
                        placeId: undefined,
                        zoneId: undefined,
                        zoneIdList: [],
                        localityIdList: [],
                        districtIdList: [],
                        districtId: undefined,
                        cityId: undefined,
                        provinceId: undefined,
                        regionId: undefined,
                        cityDisplayName: undefined,
                        cityURL: undefined,
                        zoneURL: undefined,
                        streetURL: undefined,
                    })
                    this.search();
                } else {
                    this.loading = false;
                    this.hasPolygon = true;
                    this.mapDrawing = false;
                    this.emitPlace();
                }
            } else this.loading = false;
        },
        confirmAndSearchPolygon() {
            this.loading = true;
            this.confirmPolygon();
            this.loading = false;
        },
        closeMapModal() {
            this.pmCustomEvent = {
                type: "hide-map-modal",
            }
            this.openMapModal = false;
        },
        hideMapModal() {
            if (!this.pmCustomEvent)
                this.pmCustomEvent = {
                    type: "hide-map-modal"
                }

            this.pmCustomEvent && this.$emit(this.pmCustomEvent.type, this.pmCustomEvent.payload);
        },
        emitPlace() {
            this.pmCustomEvent = {
                type: "emit-place",
                payload: {
                    aroundMe: this.aroundMe,
                    radius: this.currentRadiusKm,
                    polygon: this.searchBeanModal.polygonFromMap ? this.searchBeanModal.polygonFromMap : "",
                    polygonForDB: this.searchBeanModal.polygonForDB ? this.searchBeanModal.polygonForDB : "",
                }
            }
            this.openMapModal = false;
        },
        ...mapActions(useSearchBeanStore,["setSearchBean", "setSearchBeanByKey", "updateSearchBean"])
    },
})
